export default __webpack_public_path__ + "static/media/gallery_06.895923d4.jpg";